export default "__VITE_ASSET__pvbwgGuS__"